<!-- app页面——我的分享 -->
<template>
  <div class="myShareH5">
    <van-nav-bar title="我的分享" left-arrow @click-left="toBack" />
    <div class="backRow">
      <van-button icon="revoke" plain size="mini" type="info" @click="toRefresh">返回</van-button>
    </div>
    <div class="content">
      <!-- 文档列表 -->
      <template v-if="!showShareFolder">
        <van-pull-refresh v-model="refreshing" v-loading="loading" class="folderList" @refresh="onRefresh">
          <div v-for="item in myShareList" :key="item.folderId" class="folderItem" @click="nextDetails(item)">
            <oneShare :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneShare>
          </div>
          <div v-if="!myShareList.length" class="empty">暂无数据</div>
        </van-pull-refresh>
      </template>
      <template v-if="showShareFolder">
        <shareFolder ref="shareFolder"></shareFolder>
      </template>
    </div>

    <!-- 更多弹框 -->
    <myShareMore ref="myShareMore" :rootPrjId="mySharePrjId" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
import requestFile from "@/CommonDP/service/webShare-service";
import oneShare from "./oneShare.vue";
import myShareMore from "./myShareMore.vue";
import shareFolder from "./shareFolder/index";

export default {
  components: { oneShare, myShareMore, shareFolder },
  data() {
    return {
      page: {
        pageSize: 999,
        pageNum: 1
      }, // 分页
      myShareList: [], // 我的分享列表
      mySharePrjId: "",
      refreshing: false,
      loading: false,
      showShareFolder: false // 展示分享文件夹的内容
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getMyShareList();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },

    // 获得我的分享列表
    async getMyShareList() {
      this.loading = true;
      try {
        const { pageSize, pageNum } = this.page;
        const enterpriseId = this.enterpriseId;
        const isOut = 1;
        const res = await requestFile.queryGetShare(pageSize, pageNum, isOut, enterpriseId);
        this.myShareList = res.data || [];
      } finally {
        this.loading = false;
      }
    },

    // 刷新列表
    toRefresh() {
      this.showShareFolder = false;
      this.getMyShareList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getMyShareList();
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(function (item) {
      if (item.isExpired === 1) {
        return Notify({ type: "warning", message: "已取消分享" });
      }
      if (!item.folderId) {
        this.myShareList = item.list || []; // 分享链接
        this.mySharePrjId = item.prjId || "";
      } else {
        if (!item.isFile) {
          const value = {
            fileId: item.folderId,
            versionId: item.fileVersion,
            fileType: item.fileType,
            noNeedIssue: "true"
          };
          viewAppFileMethods(item, value);
        } else {
          this.showShareFolder = true; // 内部是文件夹，打开文件夹内容
          this.$nextTick(() => {
            this.$refs.shareFolder.getDocList_init({ ...item, prjId: this.mySharePrjId });
          });
        }
      }
    }),

    // 点击... 打开更多
    moreOpen(item) {
      if (!item.folderId) {
        if (item.isExpired === 0) this.$refs.myShareMore.setValidPrivi(item);
        else this.$refs.myShareMore.setInvalidPrivi(item);
      } else {
        this.$refs.myShareMore.setFilePrivi(item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.myShareH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 80px);
  }
}

.backRow {
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 0 10px;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
